<template>
    <BasicTabs :tabs="tabs" :tab-key="tabKey" :title="$t('vue.integrations')">
        <slot />
        <IntegrationModals />
    </BasicTabs>
</template>

<script lang="ts" setup>
import route from "ziggy-js";
import type TabItem from "@/types/Settings/TabItem";
import { CheckCircleIcon, RectangleStackIcon } from "@heroicons/vue/24/outline";
import { useTranslations } from "@/composables/useTranslations";

interface DataTableProps {
    tabKey: string;
}

withDefaults(defineProps<DataTableProps>(), {
    tabKey: "active",
});

const { t } = useTranslations();

const tabs: TabItem[] = [
    {
        title: t("vue.active"),
        key: "active",
        icon: CheckCircleIcon,
        url: route("integrations.index"),
    },
    {
        title: t("vue.available"),
        key: "available",
        icon: RectangleStackIcon,
        url: route("integrations.available.index"),
    },
];
</script>
